// @ts-nocheck
import { Amplify } from 'aws-amplify'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { CookieStorage } from 'aws-amplify/utils'

const IS_LOCALHOST = ['localhost', '127.0.0.1'].includes(window.location.hostname)

// derive base domain like ".scopetech.ai" or ".qse.group"
function getCookieDomain(hostname: string) {
  if (IS_LOCALHOST) return hostname // no Domain attribute on localhost
  const parts = hostname.split('.')

  if (parts.length < 2) return hostname

  // works for your domains: *.dev.scopetech.ai → .scopetech.ai, *.cloud.qse.group → .qse.group
  return `.${parts.slice(-2).join('.')}`
}

export const configureAmplify = ({
  userPoolId,
  userPoolClientId,
}: {
  userPoolId: string
  userPoolClientId: string
}) => {
  if (!userPoolId || !userPoolClientId) {
    console.error('Missing required AWS configuration')

    return
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: userPoolId || import.meta.env.VITE_AWS_USER_POOL_ID,
        userPoolClientId: userPoolClientId || import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID,
        identityPoolId: '',
      },
    },
  })

  const cookieStorage = {
    domain: getCookieDomain(window.location.hostname),
    secure: !IS_LOCALHOST,
    path: '/',
    expires: 365,
  }

  cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage(cookieStorage))
}

// Validate required environment variables
export const validateAwsConfig = () => {
  const requiredVars = ['VITE_AWS_USER_POOL_ID', 'VITE_AWS_USER_POOL_CLIENT_ID']

  const missingVars = requiredVars.filter(varName => !import.meta.env[varName])

  if (missingVars.length > 0) {
    console.error('Missing required AWS environment variables:', missingVars)

    return false
  }

  return true
}

// Auto-configure Amplify if environment variables are available
export const autoConfigureAmplify = ({
  userPoolId,
  userPoolClientId,
}: {
  userPoolId: string
  userPoolClientId: string
}) => {
  if (validateAwsConfig()) {
    configureAmplify({ userPoolId, userPoolClientId })

    return true
  }

  return false
}

// Auto-configure on module import
autoConfigureAmplify({
  userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID,
  userPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID,
})
